export const REDIRECT_TO_SHOPIFY_APP_INSTALL = 'REDIRECT_TO_SHOPIFY_APP_INSTALL';

export const redirectToShopifyAppInstallAction = payload => ({
  type: REDIRECT_TO_SHOPIFY_APP_INSTALL,
  payload
});
